import { call, put, takeLatest } from 'redux-saga/effects';
import { createEffect } from './creator';

import {
    MT_GET_SERVER_LIST, getServerList
} from '../actions/mt';
import MTApi from 'pc-sales/api.v2/mt';

export default [
    /**
     * 获取交易服务器列表
     */
    takeLatest(MT_GET_SERVER_LIST, createEffect(
        function* (action: Action.Async): any {
            try {
                const list = yield call(MTApi.server.get, action.payload);
                const configs = (list.data || []).map((server: any) => ({
                    value: `${server.server_type.toUpperCase()}/${server.server_id}`,
                    text: `${server.server_type.toUpperCase()}/${server.server_name}`,
                    isLeaf: false
                }));
                // const data = configs.reduce((prev: any[], curr: any[]) => ([...prev, ...curr]), []);
                yield put(getServerList.succeeded(configs));
                return configs;
            } catch (err) {
                yield put(getServerList.failed());
                throw err;
            }
        }
    ))
];
